import React, { useEffect } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import reactHtmlParser from "react-html-parser";
import PropTypes from "prop-types";

import styles from "./faqsList.scss";
import "./faqsList.css";

const CustomArrow = ({ action, url }) => {
  return (
    <div className={styles["custom-arrows"]}>
      {action ? (
        <AccordionActions style={{ transition: action ? "none" : null }}>
          <a className={styles["ancher-tag"]} href={url}>
            {action}
          </a>
        </AccordionActions>
      ) : (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.83335 5.75591C2.83335 5.83465 2.85673 5.90551 2.90349 5.9685V5.9685L7.81299 10.9055C7.85975 10.9685 7.92209 11 8.00002 11C8.07795 11 8.14029 10.9685 8.18705 10.9055V10.9055L13.0966 5.9685C13.1433 5.90551 13.1667 5.83465 13.1667 5.75591C13.1667 5.67717 13.1433 5.61417 13.0966 5.56693V5.56693L12.629 5.09449C12.5822 5.0315 12.5199 5 12.442 5C12.364 5 12.2939 5.0315 12.2315 5.09449V5.09449L8.00002 9.37008L3.7685 5.09449C3.70615 5.0315 3.63602 5 3.55809 5C3.48016 5 3.41782 5.0315 3.37106 5.09449V5.09449L2.90349 5.56693C2.85673 5.61417 2.83335 5.67717 2.83335 5.75591Z"
            fill="#2C2C2C"
          />
        </svg>
      )}
    </div>
  );
};

const FaqsList = ({ data, title, NextHead, isStructuredData }) => {
  const [result, setResult] = React.useState(data);

  const handleChange = (i) => {
    setResult((prevArr) =>
      prevArr?.map((element, index) => {
        return index === i
          ? { ...element, isExpanded: !element.isExpanded }
          : element;
      })
    );
  };

  const getFaqsStructuredData = (faqs) => {
    let structuredData = {};
    let mainEntity = [];

    faqs?.map((faq, i) => {
      mainEntity[i] = {
        "@type": "Question",
        name: faq?.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq?.answer?.replace(/(<([^>]+)>)/gi, ""),
        },
      };
    });

    structuredData = {
      "@context": "https://schema.org/",
      "@type": "FAQPage",
      mainEntity: mainEntity,
    };
    return JSON.stringify(structuredData);
  };

  useEffect(() => {
    setResult(data);
  }, [data]);

  if (!(result && result.length > 0)) return null;
  return (
    <div className={`${styles["accordion-cont"]} pdp-faq-list-faqs`}>
      {isStructuredData && (
        <NextHead>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: getFaqsStructuredData(data),
            }}
          ></script>
        </NextHead>
      )}
      {title && title.length > 0 && (
        <h2 className={styles["accordion-head"]}>{title}</h2>
      )}
      {result &&
        result.map((item, i) => (
          <Accordion
            key={i}
            className={styles["accordion"]}
            expanded={item?.isExpanded ? item?.isExpanded : false}
            onChange={() => handleChange(item.action ? null : i)}
            classes={{
              root: styles["accordion-root"],
            }}
          >
            <AccordionSummary
              classes={{
                expandIconWrapper: styles["expand-icon"],
                expanded: styles["expanded"],
              }}
              className={styles["panel-question"]}
              expandIcon={<CustomArrow action={item.action} url={item.url} />}
              aria-controls="panel1a-content"
              id="panel-header"
            >
              <h3 className={styles["accordion-question"]}>{item.question}</h3>
            </AccordionSummary>
            {item.answer ? (
              <AccordionDetails className={styles["accordion-details"]}>
                {/* <p>{item.answer}</p> */}
                <div className={styles["default_styles"]}>
                  {reactHtmlParser(item.answer)}
                </div>
              </AccordionDetails>
            ) : null}
          </Accordion>
        ))}
    </div>
  );
};

FaqsList.defaultProps = {
  isStructuredData: false,
};

FaqsList.propTypes = {
  isStructuredData: PropTypes.bool,
};

export default FaqsList;
